import { render, staticRenderFns } from "./DataPegawai.vue?vue&type=template&id=7af87652"
import script from "./DataPegawai.vue?vue&type=script&lang=js"
export * from "./DataPegawai.vue?vue&type=script&lang=js"
import style0 from "./DataPegawai.vue?vue&type=style&index=0&id=7af87652&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports